<template>
    <div class="popsale-store-list mdc-menu-surface--anchor">
        <ul id="store-list" class="mdc-list" data-mdc-auto-init="MDCList">
            <li class="mdc-list-item">
                <span class="mdc-list-item__graphic material-icons">home</span>
                {{ store.name }}
                <a :href="'../store/' + store.id" class="mdc-list-item__meta mdc-icon-button material-icons">
                    link
                </a>
            </li>
            <li class="mdc-list-item">
                <span class="mdc-list-item__graphic material-icons" data-role="location">location_on</span>
                {{ store.formated_address }}
            </li>
            <li class="mdc-list-item">
                <span class="mdc-list-item__graphic material-icons">phone</span>
                <a :href=" 'tel:' + store.tel">{{ store.tel }}</a>
            </li>

            <li class="mdc-list-item">
                <span class="mdc-list-item__graphic material-icons">access_time</span>
                <span>{{ store.is_working_hour ? '現在營業中' : '現在休息中' }} - {{ store.today_opening_hour }}</span>
                <span class="mdc-list-item__meta" v-if="store.opening_hour_in_string_array">
                    <button id="store-opt-toggle" class="mdc-icon-button" data-mdc-auto-init="MDCIconButtonToggle">
                        <i class="material-icons mdc-icon-button__icon">keyboard_arrow_down</i>
                        <i class="material-icons mdc-icon-button__icon--on">keyboard_arrow_up</i>
                    </button>
                </span>
            </li>
        </ul>

        <div id="opt-menu" class="mdc-menu mdc-menu-surface" data-mdc-auto-init="MDCMenu">
            <ul class="mdc-list" role="menu" aria-hidden="true" aria-orientation="vertical">
                <li v-for="time in store.opening_hour_in_string_array" class="mdc-list-item">
                    <span class="mdc-list-item__graphic material-icons">access_time</span>
                    {{ time }}
                </li>
            </ul>
        </div>

        <div v-show="this.apiKey && this.showMap" id="google-map" class="popsale-map-container">
            <div class="popsale-map-container__google-map mdc-elevation--z1">
                <iframe width="100%" height="100%" style="border:0"
                        :src="'https://www.google.com/maps/embed/v1/place?q=' + store.formated_address +
                        '&key=' + this.apiKey"
                        allowfullscreen>
                </iframe>
            </div>
        </div>

        <div v-if="relatedStores.length">
            <button class="mdc-button mdc-button--raised" type="button" v-on:click.prevent="isShowRelatedStores = true">相關店鋪</button>
        </div>

        <div class="popup-related-store-backdrop" v-show="isShowRelatedStores" v-on:click.prevent="isShowRelatedStores = false"></div>
        <div class="popup-related-stores-list" v-show="relatedStores.length && isShowRelatedStores">
            <div class="popsale-related-store-item" v-for="store in relatedStores">
                <div class="item-container">
                    <div class="item-icon">
                        <span class="material-icons">room</span>
                    </div>
                    <div class="item-detail">
                        <div class="item-name">{{store.name}}</div>
                        <div class="item-phone">{{store.tel}}</div>
                        <div class="item-address">{{store.formated_address}}</div>
                    </div>
                    <a class="item-url material-icons" :data-id="store.id">link</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            'offerId': {
                required: true
            },
            'store': {
                type: Object,
                required: true,
            },
            'apiKey' : {
                required: false,
            }
        },
        data: function() {
            return {
                menu: null,
                menuToggle: null,
                showMap: false,
                isShowRelatedStores: false,
                relatedStoreAPI: `/popsale/api/v1/offer/${this.offerId}/stores`,
                relatedStores: [],
            }
        },
        methods: {
            fetchRelatedStores() {
                console.log('hi');
                popsale.formRequest(this.relatedStoreAPI, 'get', null, function (response) {
                    this.relatedStores = response;
                }.bind(this))
            }
        },
        mounted() {
            window.mdc.autoInit();

            this.menu = $('#opt-menu')[0].MDCMenu;
            this.menuToggle = $('button#store-opt-toggle')[0].MDCIconButtonToggle;

            if (this.menuToggle) {
                this.menuToggle.unbounded = true;

                this.menuToggle.listen('MDCIconButtonToggle:change', function (event) {
                    this.menu.open = event.detail.isOn;
                }.bind(this));
            }

            if (this.menu) {
                this.menu.listen('MDCMenu:selected', function (event) {
                    this.menu.open = false;
                }.bind(this));

                this.menu.listen('MDCMenuSurface:opened', function (event) {
                    this.menuToggle.on = true;
                }.bind(this));

                this.menu.listen('MDCMenuSurface:closed', function (event) {
                    this.menuToggle.on = false;
                }.bind(this));
            }

            $('#store-list')[0].MDCList.listen('MDCList:action', function (event) {
                if (event.detail.index === 1) {
                    this.showMap = true;
                }
            }.bind(this));

            $('.popsale-map-container').on('click', function (event) {
                console.log('diu');
                this.showMap = false;
            }.bind(this));

            this.fetchRelatedStores();
        }
    }
</script>

<style lang="scss">
    .popsale-map-container {
        position: fixed;
        display: flex;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        width: auto;
        height: auto;
        background: rgba( black, .3);
        justify-content: center;
        align-items: center;
        z-index: 6;

        &__google-map {
            max-width: 90vw;
            max-height: 65vh;
            width: 100%;
            height: 100%;
            padding: 5px;
            border-radius: 5px;
            background: white;
            overflow: auto;
        }
    }

    .popup-related-store-backdrop {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: #00000052;
    }

    .popup-related-stores-list {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 3;
        background: white;
        max-height: 65vh;
        width: 50vw;
        padding: 0 10px;
        border-radius: 5px;
        overflow: auto;

        @media screen and (max-width: 840px){
            width: 80vw;
        }

        .popsale-related-store-item {
            margin-top: 5px;
            margin-bottom: 5px;

            &:first-child {
                margin-top: 10px;
            }

            &:last-child {
                margin-bottom: 10px;
            }

            .item-container {
                position: relative;
                display: flex;
                justify-content: space-between;
                align-items: center;
            }

            .item-icon > .material-icons {
                font-size: 35px;
                background: var(--mdc-theme-primary);
                border-radius: 100%;
                padding: 5px;
                color: white;
            }

            .item-detail {
                margin-left: 25px;
                margin-right: auto;

                .item-name {
                    font-size: 1em;
                    font-weight: 600;
                }

                .item-phone, .item-address {
                    font-size: .9em;
                    color: gray;
                }

            }

            a.item-url.material-icons {
                cursor: pointer;
            }
        }
    }
</style>